import { IdleMonitorActions, IdleMonitorKeys } from '../constants/IdleMonitor';

export function updateIdleMonitor(idleStatus) {
  return {
    type: IdleMonitorActions.UPDATE,
    payload: {
      [IdleMonitorKeys.IDLE_STATUS]: idleStatus,
    },
  };
}

export function startIdleMonitor() {
  return {
    type: IdleMonitorActions.START,
  };
}
